import React from "react";
import { PeopleRegular, PeopleAddRegular, AddRegular } from "@fluentui/react-icons";
import { useTranslation } from "../../shared/translation/Translation";
import EmployeesField from "../employeesField/EmployeesField";

export interface EmployeesAddAndEditFieldProps {
    isFormTypeUpdate: boolean;
    additionalAttendeesEmailsText: string[];
    newAdditionalAttendeesEmailsText: string[];
    onAdditionalAttendeesEmailsDataChange: (emails: string[]) => void;
    onNewAdditionalAttendeesEmailsDataChange: (emails: string[]) => void;
    isExpanded: boolean;
}

const EmployeesAddAndEditField: React.FC<EmployeesAddAndEditFieldProps> = (props: EmployeesAddAndEditFieldProps) => {
    const messages = useTranslation();

    if (props.isExpanded === false) {
        return null;
    }

    return (
        <>
            <EmployeesField
                placeholder={messages.meetingModals.additionalAttendeeEmailsPlaceholder}
                iconComponent={props.isFormTypeUpdate ? <PeopleRegular /> : <PeopleAddRegular />}
                emails={props.additionalAttendeesEmailsText}
                handleDataChange={(emails) => {
                    props.onAdditionalAttendeesEmailsDataChange(emails);
                }}
                disabled={props.isFormTypeUpdate}
            />
            {props.isFormTypeUpdate && (
                <EmployeesField
                    placeholder={messages.updateMeeting.newAdditionalAttendeeEmailsPlaceholder}
                    iconComponent={<AddRegular />}
                    emails={props.newAdditionalAttendeesEmailsText}
                    handleDataChange={(emails) => {
                        props.onNewAdditionalAttendeesEmailsDataChange(emails);
                    }}
                />
            )}
        </>
    );
};

export default EmployeesAddAndEditField;
